import vuex from '@/store'

export default {
  shortInstruction(instructions){
    const text = instructions.replace(/<\/?[^>]+(>|$)/g, "");
    const short = text.substring(0, 200).trim()
    return short + '...'
  },
  removeUnnecessaryIngredients(ingredients){
    return ingredients.filter(ingredient => {
      return !ingredient.includes('personer') && !ingredient.includes('serveringer')
    })
  },
  orderRecipeBy(recipes, orderBy){
    let orderedRecipes;
    const favoriteIds = vuex.getters.getFavorites;
    const doneIds = vuex.getters.getDone;
    switch (orderBy) {
      case 'new': orderedRecipes = recipes.sort((a,b) => new Date(b.Created) - new Date(a.Created))
        break;
      case 'old': orderedRecipes = recipes.sort((a,b) => new Date(a.Created) - new Date(b.Created))
        break;
      case 'az':
        orderedRecipes = recipes.sort((a,b) => a.Title.localeCompare(b.Title))
        break;
      case 'za':
        orderedRecipes = recipes.sort((a,b) => b.Title.localeCompare(a.Title))
        break;
      case 'done':
        orderedRecipes = recipes.filter(recipe => doneIds.includes(recipe.Id.toString()))
        break;
      case 'favorite':
        orderedRecipes = recipes.filter(recipe => favoriteIds.includes(recipe.Id.toString()))
        break;
      case 'random':
        orderedRecipes = recipes.sort(() => Math.random() < 0.5 ? -1 : 1)
        break;
      default:
        break;
    }
    return orderedRecipes;
  },
  removeHtml(html) {
    html = html.replace(/\u00A0/g, '')
    html = html.replace(/<br \/>/g, "|||");
    html = html.replace(/(?:\r\n|\r|\n)/g, '|||');
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    html = tmp.textContent || tmp.innerText;
    return html.split('|||').filter(instruction => instruction.length > 2);
  }
}